'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ActionButtonsContainer = styled__default["default"].div.withConfig({
  componentId: "sc-sd7piu-0"
})(["display:flex;gap:1rem;"]);

exports["default"] = ActionButtonsContainer;
